export * from './src/ricos-v1-embeddable-item-ricos-embeddables.meta.js';
